module.exports = {"SYS":{"confirmButtonText":"Comfirm","cancelButtonText":"Cancel"},"user":{"title":"Personal center","Exit":"Exit system","Processing":"to-do list","initiated":"I initiated","transferring":"transferring work","phoneService":"Telephone customer service","Accounts":"Account center","modifyPassword":"change Password","Language":"CH/EN","about":"about","confirmExit":"Confirm Exit ?","confirmChangeLanguage":"Whether to switch languages","ScExit":"exit successfully","loadingtext":"Exiting..."}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/languages/en_us.json
// module id = UcyB
// module chunks = 1